module.exports = __webpack_public_path__ + "media/application/images/icons/print-e9f2d4c56601c173f893ae24a168077e.svg";